module.exports = __webpack_public_path__ + "img/service_managa.cae66c71.png";